/** @typedef {import('./HttpMethods').default} HttpMethods */
const HttpClient = require('./HttpClient');

/**
 * @template Body
 * @typedef {import('./HttpResponse').default<Body>} HttpResponse
 */

/**
 * @abstract
 * @extends {HttpClient}
 */
class BrowserClient extends HttpClient {
	/**
	 * @template ResponseBody
	 * @param {HttpMethods} method
	 * @param {string} url
	 * @param {Headers=} headers
	 * @param {object|string=} body
	 * @param {boolean=} includeCredentials
	 * @returns {Promise<HttpResponse<ResponseBody>>}
	 */
	async makeRequest(
		method,
		url,
		headers = new Headers(),
		body,
		includeCredentials = false
	) {
		const optionList = {
			body: body
				? this.parseRequestBody(body, headers.get('Content-Type'))
				: undefined,
			/** @type {'include'|'same-origin'} */
			credentials: includeCredentials ? 'include' : 'same-origin',
			headers,
			method: method.toUpperCase(),
		};

		const response = await fetch(url, optionList);

		return this.parseResponse(
			response,
			response.headers.get('Content-Type')
		);
	}
}

module.exports = BrowserClient;
